import { getProjectGitSettingsFromStorage } from './storageUtils';

/** `settings.github` block for VishMaker WebSocket payloads (chat, build contract, etc.). */
export function buildWireGithubSettings(
    projectId: string | number | null | undefined
): { github: { repo_url: string; branch: string; token: string } } {
    const g = getProjectGitSettingsFromStorage(projectId, { includeGlobalFallback: true });
    return {
        github: {
            repo_url: g?.repo_url ?? '',
            branch: g?.branch ?? '',
            token: g?.token ?? '',
        },
    };
}
